import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { IRawFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IStevieText, setText } from './stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { phaserUtil } from '../engine/phaserUtil-sidecar'

export const textInputAlphabet =
  'abcdefghijklmnopqrstuvwxyz1234567890-+*=/.,;:\'"?!()'
export interface ITextInput extends IEntity {
  text: IStevieText
  imageBackground: Phaser.GameObjects.Image
  isFocused: boolean
  onChange: (newVal: string) => void
  selectionStart: number
}

const objs: ITextInput[] = []
let focusedTextInput: ITextInput | null = null

let w = 50
let h = 10
let oy = h * 3 + 2 * 3
export const defaultFrames: IRawFrameInfo[] = [
  frameInfo.fiRaw(4, 2, oy + 2, w, h),
  frameInfo.fiRaw(4, 2, oy + 2 + h + 2, w, h),
  frameInfo.fiRaw(4, 2, oy + 2 + 2 + 2 + h + h, w, h),
  // disabled: frameInfo.fi32(1, 5, 10),
  // bought: frameInfo.fi32(1, 5, 11),
]

export function create(
  layer: Phaser.GameObjects.Container,
  x: number,
  y: number,
  text: string,
  onChange: (newVal: string) => void,
) {
  let imageBackground = spriteMap.createImageFromRawFrameInfo(
    layer,
    defaultFrames[0],
    x,
    y,
    4,
  )

  let _text = stevieText.create(scene.getContext().font16, x + 10 + 4, y + 10)
  stevieText.setText(_text, text)

  let obj: ITextInput = {
    eType: 'text-input',
    id: common.createId(),
    imageBackground,
    isFocused: false,
    text: _text,
    onChange,
    selectionStart: 0,
    isDead: false,
  }
  objs.push(obj)

  phaserUtil.setInteractive(imageBackground)

  // imageBackground.on('pointerover', () => {
  //   obj.isOver = true
  // })
  // imageBackground.on('pointerout', () => {
  //   obj.isOver = false
  //   obj.isMouseDown = false
  // })

  imageBackground.on('pointerdown', () => {
    // obj.isFocused = true
    setFocus(obj)
    // let scene = common.getScene()
    // if (scene.game.input.activePointer.rightButtonDown()) {
    //   obj.isMouseRightDown = true
    // } else {
    //   obj.isMouseDown = true
    // }
  })
  imageBackground.on('pointerup', () => {
    // if (obj.isMouseDown) {
    //   obj.isMouseDown = false
    //   if (obj.imageBackground.visible) {
    //     obj.onClick()
    //   }
    // }
    // if (obj.isMouseRightDown) {
    //   obj.isMouseRightDown = false
    // }
  })
  return obj
}

export function setVisible(obj: ITextInput, visible: boolean) {
  obj.imageBackground.visible = visible
  stevieText.setVisible(obj.text, visible)
  if (!visible) {
    removeFocus(obj)
  }
}

export function hasFocus() {
  return focusedTextInput !== null
}

export function handleKeyboardInput(
  key: string,
  keyCode: number,
  code: string,
) {
  console.log('key input', key, keyCode, code)

  let obj = focusedTextInput

  if (obj) {
    let newText = obj.text.text
    if (textInputAlphabet.includes(key.toLowerCase())) {
      newText += key
    }

    let del = () => {
      if (obj && obj.text.text.length > 0) {
        newText = newText.substring(0, obj.text.text.length - 1)
      }
    }
    if (code === 'Space') {
      newText += ' '
    }
    if (code === 'Backspace') {
      del()
    }
    if (code === 'Delete') {
      del()
    }

    if (newText !== obj.text.text) {
      console.log('text change!')
      stevieText.setText(obj.text, newText)
      obj.onChange(newText)
    }
  }
}

export function setFocus(obj: ITextInput) {
  l.forEach(objs, (c) => {
    c.isFocused = false
  })
  obj.isFocused = true
  focusedTextInput = obj
}
export function removeFocus(obj: ITextInput) {
  if (focusedTextInput === obj) {
    focusedTextInput = null
    obj.isFocused = false
  }
}

export function kill(obj: ITextInput) {
  obj.isDead = true
  removeFocus(obj)
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.imageBackground.destroy()
    stevieText.kill(c.text)
  })
}

export function update(obj: ITextInput) {
  if (obj.isFocused) {
    spriteMap.setRawFrame(obj.imageBackground, defaultFrames[2], 0, 0)
  } else {
    spriteMap.setRawFrame(obj.imageBackground, defaultFrames[0], 0, 0)
  }
}
